/* File Automatically Generated by LSC. Please do not edit manually. */

import {Routes} from '@angular/router';

export const generatedRoutes: Routes = [
  {
    path: 'ngx-asr',
    loadChildren: () => import('@labshare/ngx-asr').then(m => m.NgxAsrModule)
  }
];
